// Custom names live in localStorage, which the server can't read. Until the
// first client render has hydrated, return the default so server and client
// HTML match; _app then flips this flag and re-renders once.
let featureNamesHydrated = false;

export const markFeatureNamesHydrated = () => {
  featureNamesHydrated = true;
};

export const getFeatureName = (
  defaultName: string,
  featureKey: string
): string => {
  if (typeof window === "undefined" || !featureNamesHydrated) {
    return defaultName;
  }

  try {
    const storedOrg = localStorage.getItem("org");
    if (!storedOrg) return defaultName;

    const org = JSON.parse(storedOrg);
    const names = org.customFeatureNames;
    if (!names) return defaultName;

    const key = featureKey.toLowerCase();
    return (
      names[featureKey] ||
      names[key] ||
      names[key.replace(/s$/, "")] ||
      names[key + "s"] ||
      defaultName
    );
  } catch (error) {
    console.error("Error getting custom feature name:", error);
    return defaultName;
  }
};
